import RxLink from "./RxLink";

export default RxLink;
